import React from "react";
import { Leaf, Clock, Users, ChevronRight, Sparkles } from "lucide-react";

function LoadingCard() {
  return (
    <div className="rounded-3xl p-6 overflow-hidden" style={{ border: "1px solid #E5E0D8", backgroundColor: "#FFFFFF" }}>
      <div className="shimmer h-4 w-32 rounded-lg mb-3" />
      <div className="shimmer h-6 w-2/3 rounded-lg mb-2" />
      <div className="shimmer h-4 w-1/2 rounded-lg mb-4" />
      <div className="flex gap-2">
        {[1,2,3,4].map(i => <div key={i} className="shimmer h-6 w-16 rounded-full" />)}
      </div>
    </div>
  );
}

export default function TodaySuggestion({ data, onCookThis, isLoading }) {
  if (isLoading) return <LoadingCard />;
  if (!data) return null;

  const { ritu, recipe } = data;

  return (
    <div
      className="rounded-3xl overflow-hidden animate-fade-up opacity-0"
      style={{ border: `1.5px solid ${ritu.color}35`, backgroundColor: ritu.color + "08", animationFillMode: "forwards" }}
      data-testid="today-suggestion-card"
    >
      <div className="px-6 py-5">
        {/* Season header */}
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: ritu.color + "25" }}>
            <Leaf size={12} style={{ color: ritu.color }} strokeWidth={2} />
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs font-bold uppercase tracking-widest" style={{ color: ritu.color, fontFamily: "Manrope, sans-serif" }}>
              Today's Suggestion
            </span>
            <span className="text-xs px-2 py-0.5 rounded-full" style={{ backgroundColor: ritu.color + "18", color: ritu.color, fontFamily: "Manrope, sans-serif" }}>
              {ritu.name} ({ritu.english}) · {ritu.months}
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div className="flex-1 min-w-0">
            <h3 className="font-serif font-bold text-xl mb-1" style={{ color: "#2D3436" }} data-testid="suggestion-recipe-name">
              {recipe.recipe_name}
            </h3>
            <p className="text-sm italic mb-3" style={{ color: "#5D6D7E", fontFamily: "Manrope, sans-serif" }}>
              &ldquo;{recipe.tagline}&rdquo;
            </p>

            {/* Key ingredient pills */}
            <div className="flex flex-wrap gap-1.5 mb-3">
              {recipe.ingredients_used?.slice(0, 5).map((ing, i) => (
                <span key={i} className="text-xs px-2.5 py-1 rounded-full font-medium"
                  style={{ backgroundColor: ritu.color + "15", color: ritu.color, border: `1px solid ${ritu.color}30`, fontFamily: "Manrope, sans-serif" }}>
                  {ing.name}
                </span>
              ))}
            </div>

            {/* Times */}
            <div className="flex items-center gap-4 text-xs" style={{ color: "#9AA5B1", fontFamily: "Manrope, sans-serif" }}>
              <span className="flex items-center gap-1"><Clock size={11} /> {recipe.cook_time}</span>
              <span className="flex items-center gap-1"><Users size={11} /> Serves {recipe.servings}</span>
              <span className="flex items-center gap-1"><Sparkles size={11} /> {ritu.description.split(".")[0]}</span>
            </div>
          </div>

          {/* CTA */}
          <button
            data-testid="cook-today-btn"
            onClick={() => onCookThis(recipe)}
            className="flex items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-sm transition-all hover:scale-105 whitespace-nowrap flex-shrink-0"
            style={{ backgroundColor: ritu.color, color: "#FFFFFF", boxShadow: `0 6px 20px ${ritu.color}40`, fontFamily: "Manrope, sans-serif" }}
          >
            Cook This Today
            <ChevronRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
